import React from "react";
import styled from "styled-components";
import SidebarHeader from "components/Sidebar/layout/SidebarHeader";
import TextButton from "components/TextButton";
import ServiceType from "./ServiceType";
import Endpoint from "./Endpoint";
import { ArrowBack } from "@mui/icons-material"
import TooltipIconButton from "components/TooltipIconButton";

const TitleSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
`;

const Title = styled.h2`
  color: white;
`;

const Description = styled.div`
  p {
    color: #C4C4C4;

    &:not(.contact) {
      margin-bottom: 15px;
    }

    a {
      text-decoration: underline;
    }
  }
`;

const WebMapServicesUpload = ({ types, onClose, onBack }) => {
  return (
    <>
      <SidebarHeader onClose={onClose}>
        <TooltipIconButton title="Back" ariaLabel="back" placement="bottom" onClick={onBack} size={44}>
          <ArrowBack />
        </TooltipIconButton>
      </SidebarHeader>
      <TitleSection>
        <Title>Web Map Service</Title>
        <TextButton text="Connect" />
      </TitleSection>
      <ServiceType types={types} />
      <Endpoint />
      <Description>
        <p>Copy and paste the endpoint to connect web map service. WMTS, TMS and WMS are supported.</p>
        <p className="contact">Looking for a web map Service Provider?  <a href="mailto:sales@fastmap.ca">Contact Sales</a></p>
      </Description>
    </>
  );
};

export default WebMapServicesUpload;
